import React, { Component } from 'react';
import { PersonInfoForm } from 'components';
import { PageContainer } from 'pages';

class AddPersonPage extends Component {
  render () {
    return (
      <PageContainer maxHeight>
        <PersonInfoForm />
      </PageContainer>
    );
  }
}

export default AddPersonPage;
